var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"baseChart",attrs:{"id":"base-chart-id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }